import React, {Component} from 'react';
import {connect} from "react-redux";

import {Row, Col} from 'reactstrap';

import * as actions from '../../actions/ApiActions';

import SearchHeader from '../../components/SearchHeader/SearchHeader'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import LogoCarousel from '../../components/LogoCarousel/LogoCarousel';
import ContactForm from '../../components/ContactForm/ContactForm';

class TeamContainer extends Component {

    render() {
        const {sendContactMessage} = this.props;

        return (
          <div>
            <Section pattern header>
              <Headline pageTitle>
                Über uns
              </Headline>
              <Headline center subtitle>Ein starkes, interdisziplinäres Team</Headline>
            </Section>

            <div>

              <svg style={{width:0,height:0,position:'absolute'}} aria-hidden="true" focusable="false">
                <linearGradient id="gradient">
                  <stop offset="0%" stop-color="#eeeeee" />
                  <stop offset="100%" stop-color="#cbcbcd" />
                </linearGradient>
              </svg>

                <Section triangle greyGradient backgroundImage={'/img/team.png'}>
                    <Row>
                        <Col md={6} xs={12}>
                          <Headline orange>Hinter Quickdoctor stehen wir</Headline>
                            <p>Max Schüler, Nina Sofie Krah und Lukas Liß.
                              Wir studieren Zahnmedizin, Management
                              und Informatik.<br /><br /></p>
                        </Col>
                        <Col md={6} xs={12}>
                            <img style={{position: 'absolute', bottom: 0}} src={'/img/team.png'} />
                        </Col>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <Col md={8} xs={12}>
                            <Headline>Wie aus dem Problem eine Idee entstanden ist</Headline>

                            <p>Viele Patienten suchen kurzfristig einen Arzttermin, müssen häufig jedoch lange Wartezeiten
                                in Kauf nehmen. Auf der anderen Seite können Ärzte kurzfristig ausgefallene Termine oft
                                nicht mehr neu vermitteln.
                                <br/><br/>
                                Mit Quickdoctor lösen wir dieses zweiseitige Problem, indem wir Patienten die Möglichkeit geben,
                                schnell einen Termin bei einem gewünschten Arzt zu erhalten und Ärzte bei der Vergabe
                                von kurzfristig ausgefallenen Arztterminen unterstützen.
                                <br/><br/>
                                Es handelt sich hierbei um eine Win-Win-Situation: Auf der einen Seite wird die Dauer
                                des Suchprozesses nach einem kurzfristig frei verfügbaren Termin für den Patienten
                                deutlich reduziert. Der Arzt nutzt seine Ressourcen mithilfe von Quickdoctor besser aus
                                und kann den Patienten mit einer guten Behandlung von sich überzeugen und so langfristig
                                an seine Praxis binden.
                            </p>
                        </Col>
                        <Col md={4} xs={12}>
                            <img src={'/img/avatars/Team 1.png'} />
                        </Col>
                    </Row>

                </Section>

              <Section>
                <Headline>Unsere Partner und Unterstützer</Headline>
                <LogoCarousel>
                  <img src="/img/avatars/logos/logo1.png" />
                  <img src="/img/avatars/logos/logo2.png" />
                  <img src="/img/avatars/logos/logo3.png" />
                  <img src="/img/avatars/logos/logo4.png" />
                  <img src="/img/avatars/logos/logo5.png" />
                  <img src="/img/avatars/logos/logo6.png" />
                  <img src="/img/avatars/logos/logo7.png" />
                  <img src="/img/avatars/logos/logo8.png" />
                  <img src="/img/avatars/logos/logo9.png" />
                </LogoCarousel>
              </Section>

              <Section grey>
                <Row>
                  <Col md={5} xs={12}>
                    <Headline>Haben Sie noch Fragen?</Headline>
                    <Headline small>Dann kommen Sie mit uns in Kontakt.</Headline>
                    <ContactForm sendAction={(body) => sendContactMessage(body)} />
                  </Col>

                  <Col md={{ size: 5, offset: 1 }} xs={12}>
                    <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-end', flexDirection: 'column' }}>
                      <Headline>Bekannt aus:</Headline>
                      <img src={'/img/bekannt-aus.png'} />
                    </div>
                  </Col>
                </Row>

              </Section>

            </div>
          </div>
        )
    }
}

export default connect(null, actions)(TeamContainer);



// WEBPACK FOOTER //
// ./src/container/public/TeamContainer.js